module.exports = __webpack_public_path__ + "img/regular_burnt_fault.1641ca20.svg";